import { CommonModule } from '@angular/common';
import { APP_INITIALIZER, NgModule, Optional, SkipSelf } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToasterModule, ToasterService } from 'angular2-toaster';

import { AuthService } from './auth.service';
import { ConfigService } from './config.service';
import { IotService } from './iot.service';
import { throwIfAlreadyLoaded } from './module-import-guard';
import { UtilService } from './util.service';
import { JQ_TOKEN } from './jquery.service';
import { SimpleModalComponent } from './simple-modal/simple-modal.component';
import { ClimateReadingsService } from './climate-readings.service';
import { MixpanelService } from '../shared/mixpanel.service';
import { RoutingstateService } from 'app/shared/routingstate.service';

const jQuery = window['$'];
// save the reference so we can point JQ_TOKEN to the global jQuery object

export function initConfig(config: ConfigService) {
  return () => config.load();
}

@NgModule({
  imports: [CommonModule, BrowserAnimationsModule, ToasterModule],
  exports: [ToasterModule, SimpleModalComponent],
  declarations: [SimpleModalComponent],
  providers: [
    AuthService,
    { provide: JQ_TOKEN, useValue: jQuery },
    UtilService,
    ToasterService,
    IotService,
    ConfigService,
    ClimateReadingsService,
    MixpanelService,
    RoutingstateService,
    {
      provide: APP_INITIALIZER,
      useFactory: initConfig,
      deps: [ConfigService],
      multi: true
    }
  ]
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule
  ) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/core/core.module.ts